import { CustomField } from 'components/Table/types';

export const isCustomField = (data: any): data is CustomField =>
  data && 'label' in data;
